import { render } from "./ResourceSelector.vue?vue&type=template&id=04fb74f6"
import script from "./ResourceSelector.vue?vue&type=script&lang=js"
export * from "./ResourceSelector.vue?vue&type=script&lang=js"

import "./ResourceSelector.vue?vue&type=style&index=0&id=04fb74f6&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__